import * as THREE from 'three'
import React, {useMemo, useState} from 'react'
import {useComputerScreenTexture} from '../hooks/useComputerScreenTexture.jsx'
import {COMPUTER_SCREEN_PROPS} from '../utils/constants.jsx'

export function ComputerScreen() {
    const [videoTexture, videoRef] = useComputerScreenTexture()
    const [isPlaying, setIsPlaying] = useState(true)
    const screenGeometry = useMemo(() => new THREE.PlaneGeometry(2, 1), [])

    const togglePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause()
            } else {
                videoRef.current.play()
            }
            setIsPlaying(!isPlaying)
        }
    }

    return (
        <mesh
            onClick={togglePlayPause}
            position={COMPUTER_SCREEN_PROPS.position}
            scale={COMPUTER_SCREEN_PROPS.scale}
            geometry={screenGeometry}
            rotation={COMPUTER_SCREEN_PROPS.rotation}
            dispose={null}
            name='computer_screen'
        >
            <meshBasicMaterial
                map={videoTexture}
                toneMapped={false}
            />
        </mesh>
    )
}